import { App } from 'vue'
import Checkbox from './LpCheckbox.vue'

Checkbox.install = (Vue: App) => {
  Vue.component(Checkbox.name, Checkbox)
}

export default Checkbox
